export default __webpack_public_path__ + "static/media/splash.fbc97b59.svg";